<template>
  <div class="group-upload-list">
    <div v-for="(group, gIdx) in groupList" :key="group.group.id || group.group.name" class="group-upload-block">
      <div class="group-title">{{ group.group.name }}</div>
      <el-upload
        :action="''"
        :http-request="(params) => handleUpload(params, gIdx)"
        :file-list="group.list"
        :show-file-list="false"
        :before-upload="beforeUpload"
        multiple
        class="group-el-upload"
        list-type="text"
      >
        <div class="el-upload__text">
          <em style="margin-right: 20px">
            <img src="../assets/img/upload.png" style="width: 16px;height: 15px;margin-right: 10px">点击上传
          </em>
          <span style="margin-right: 20px;color: #E5E5E5;">|</span>拖动文件到框内
          <p v-if="type === 'video'">支持MP4格式，单个视频文件大小限制1024M</p>
          <p v-if="type === 'audio'">支持MP3格式，单个音频文件大小限制50M</p>
          <p v-if="type === 'file'">支持多个文件上传，格式支持PPT、Word、Excel、PDF，单个文件大小50M内</p>
        </div>
      </el-upload>
      <el-progress
        v-if="progressMap[gIdx] && progressMap[gIdx].show && progressMap[gIdx].percent < 100"
        :percentage="progressMap[gIdx].percent"
        :color="color"
        style="width: 100%; margin: 10px 0;"
      />
      <!-- <ul class="group-file-list">
        <li v-for="(file, fIdx) in group.list" :key="file.uid || file.id || file.path" class="group-file-item">
          <span class="file-name">{{ file.name }}</span>
          <el-button type="text" size="mini" @click="removeFile(gIdx, fIdx)" style="color:#ff4d4f;">删除</el-button>
        </li>
      </ul> -->

      <div class="file-group-hover-background my-upload-list" v-if="group.list.length > 0">
        <div v-for="(file, fIdx) in group.list" :key="file.uid || file.id || file.path" class="group-file-item">
          <div class="file-row">
						<img :src="util.setFileIcon(file.path)" class='my-file'>
						<span class="file-name">{{ file.name }}({{ file.size }})</span>
					</div>
					<div style="flex-shrink: 0;">
						<button element-loading-spinner="el-icon-loading" type="button"
							class="icon-btn" @click="showFile(file.path)">预览</button>
						<el-popconfirm cancel-button-type="Text" confirm-button-type="Text" :hide-icon="true"
							width="250" placement="bottom-end" @onConfirm='removeFile(gIdx, fIdx)'
							title="确定删除该文件吗？" style="padding: 0;">
							<button slot="reference" element-loading-spinner="el-icon-loading" type="button" class="icon-btn icon-delete">
								删除
							</button>
						</el-popconfirm>
					</div>
        </div>
			</div>
    </div>
  </div>
</template>

<script>
import { client } from '@/util/js/ali_oss.js'
export default {
  name: 'GroupFileUpload',
  props: {
    groupList: {
      type: Array,
      required: true
    },
    type: {
      // 'file' | 'video' | 'audio'
      type: String,
      required: true
    },
    alOssUrl: {
      type: String,
      required: true
    },
    util: {
      type: Object,
      required: true
    },
    color: {
      type: String,
      default: '#67C23A'
    }
  },
  data() {
    return {
      progressMap: {} // { [gIdx]: { show: Boolean, percent: Number } }
    }
  },
  methods: {
    handleUpload(obj, groupIdx) {
      const file = obj.file
      const fileName = this.util.getFileName() + file.name
      const size = this.util.getFileSize(file.size)
      // 进度条
      this.$set(this.progressMap, groupIdx, { show: true, percent: 0 })
      client().multipartUpload(fileName, file, {
        progress: (p) => {
          setTimeout(() => {
            this.progressMap[groupIdx].show = true
            this.progressMap[groupIdx].percent = Math.floor(p * 100)
          }, 300)
        }
      }).then(result => {
        if (result.res.statusCode === 200) {
          let nweObj = {
            name: file.name,
            url: this.alOssUrl + result.name,
            path: result.name,
            size: size
          }
          nweObj.weigh = this.groupList[groupIdx].list.length
          this.groupList[groupIdx].list.push(nweObj)
          this.$emit('update:groupList', this.groupList)
        } else {
          this.$message.error('上传失败！')
        }
        this.progressMap[groupIdx].show = false
        this.progressMap[groupIdx].percent = 0
      }).catch(() => {
        this.progressMap[groupIdx].show = false
        this.progressMap[groupIdx].percent = 0
        this.$message.error('上传失败！')
      })
    },
    showFile(path) {
      this.$emit('showFile', path)
    },
    removeFile(groupIdx, fileIdx) {
      this.groupList[groupIdx].list.splice(fileIdx, 1)
      this.$emit('update:groupList', this.groupList)
    },
    beforeUpload(file) {
      // 附件
      if (this.type === 'file') {
        const isLt50M = file.size / 1024 / 1024 < 50
        if (!isLt50M) {
          this.$message.error('上传文件大小不能超过 50MB!')
          return false
        }
        const ext = file.name.split('.').pop().toLowerCase()
        if (!['ppt', 'pptx', 'doc', 'docx', 'xls', 'xlsx', 'pdf'].includes(ext)) {
          this.$message.error('当前文件只能上传PPT、Word、Excel、PDF格式！')
          return false
        }
        return true
      }
      // 视频
      if (this.type === 'video') {
        const isLt1024M = file.size / 1024 / 1024 < 1024
        if (!isLt1024M) {
          this.$message.error('上传文件大小不能超过 1024MB!')
          return false
        }
        const ext = file.name.split('.').pop().toLowerCase()
        if (ext !== 'mp4') {
          this.$message.error('当前文件只能上传mp4格式！')
          return false
        }
        return true
      }
      // 音频
      if (this.type === 'audio') {
        const isLt50M = file.size / 1024 / 1024 < 50
        if (!isLt50M) {
          this.$message.error('上传文件大小不能超过 50MB!')
          return false
        }
        const ext = file.name.split('.').pop().toLowerCase()
        if (ext !== 'mp3') {
          this.$message.error('当前文件只能上传mp3格式！')
          return false
        }
        return true
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.group-upload-list {
  width: 100%;
}
.group-upload-block {
  margin-bottom: 30px;
  background: #fafbfc;
  border-radius: 6px;
  padding: 16px 20px 10px 20px;
  box-shadow: 0 2px 8px rgba(31,180,249,0.06);
  /deep/ .el-upload {
    width: 100%;
  }
  /deep/ .el-upload__text {
    min-height: 60px;
    height: 100%;
    padding-top: 20px;
    p {
      font-size: 12px;
      color: #999;
      margin: 0;
    }
  }
}
.group-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}
.group-el-upload {
  margin-bottom: 10px;
  background: #FFFFFF;
  border: 1px dashed #DCDFE6;
  border-radius: 5px;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    border-color: var(--el-color-primary);
  }
}
.group-file-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.group-file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 4px;
  &:hover {
		background-color: #F7F7F7;
		}
}

.file-group-hover-background {
		
	}
  .file-row {
		max-width: calc(100% - 120px);
		display: flex;
		align-items: center;
	}
	.file-name {
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
		padding: 0;
	}
  .icon-btn {
		height: 33px;
		border-radius: 5px;
		padding: 10px 5px;
		font-size: 14px;
		color: #666;
		// background: #f5f5f5;
		border: none;
		display: inline-flex;
		align-items: center;
		transition: background 0.2s;
		margin-right: 5px;
		cursor: pointer;
		&:hover {
			background: #ececec;
		}
	}
	.icon-delete {
		color: #FF0000;
		// background: #ff4d4f;
		&:hover {
			background: #ececec;
		}
	}
</style>
